import { LeihBarTranslation } from 'locales/de/pages/LeihBar/leihbar';

const en: LeihBarTranslation = {
  title: 'leihBar',
  addToCart: 'Add to cart',
  selectProduct: 'Select offer',
  lender: 'Borrower',
  internalNote: 'Internal Note',
  internalArticleNote: 'Interner article note',
  tabs: {
    products: 'Products',
    categories: 'Categories',
    locations: 'Locations',
    bundles: 'Bundles',
    orders: 'Order history'
  },
  profile: {
    title: 'leihBar Profile',
    tabs: {
      mailtemplates: 'Mail Templates',
      vacation: 'Vacation',
      openingHours: 'Opening hours'
    },
    selectEntitlementGroup:
      'You are assigned to multiple entitlement groups. Please select the group you want to edit:'
  },
  tooltips: {
    shareButton: 'Copy the link to this product to your clipboard',
    myOffers: 'Show only your offers and offers you can edit',
    bookingCanceled: 'Booking has been canceled',
    endTimeOverdue: 'The end date of the booking is in the past'
  },
  category: {
    create: {
      name: 'Categoryname',
      icon: 'Icon',
      createModalTitle: 'Create Category',
      editModalTitle: 'Edit Category'
    },
    columns: { name: 'Categoryname', icon: 'Icon' },
    dialogs: {
      deleteConfirm: {
        title: 'Really delete?',
        message: 'Do you really want to delete the category?'
      }
    },
    alerts: {
      successfulCreate: 'The category has been created.',
      successfulUpdate: 'The category has been updated.',
      successfulDelete: 'The category has been deleted.',
      failedCreate: 'The category could not be created.',
      failedUpdate: 'The category could not be updated.',
      failedDelete: 'The category could not be deleted.',
      failedImageUpload: 'The icon could not be uploaded.',
      errorLoading: 'The category could not be loaded.'
    }
  },
  location: {
    create: {
      name: 'Location',
      createModalTitle: 'Create Location',
      editModalTitle: 'Edit Location'
    },
    columns: { name: 'Location' },
    dialogs: {
      deleteConfirm: {
        title: 'Really delete?',
        message: 'Do you really want to delete the location?'
      }
    },
    alerts: {
      successfulCreate: 'The location has been created.',
      successfulUpdate: 'The location has been updated.',
      successfulDelete: 'The location has been deleted.',
      failedCreate: 'The location could not be created.',
      failedUpdate: 'The location could not be updated.',
      failedDelete: 'The location could not be deleted.',
      errorLoading: 'The location could not be loaded.'
    }
  },
  product: {
    location: 'Location',
    name: 'Offer',
    description: 'Description',
    categories: 'Categories',
    domain: 'Domain',
    hint: 'Hint',
    availability: {
      header: 'Availability',
      partiallyAvailableDescription: 'Partially available',
      availableDescription: 'Full day available'
    },
    noMaxBooking: 'No Booking Time Limit',
    noPreparationTime: 'No preparation time',
    contact: 'Contact',
    recurringInterval: 'Every {{weekday}} from {{start}} until {{end}}',
    filter: {
      myOffers: 'My offers'
    },
    bundle: {
      content: 'Bundle Content',
      noProductsSelected: 'No products selected yet',
      noProductsAvailable:
        'No products available with this name. Please check your input in the searchfield.',
      navigateToProduct: 'Go to Product'
    },
    create: {
      createHeading: 'New Product',
      editHeading: 'Edit Product',
      bundleHeading: 'Add products to the bundle',
      productname: 'Productname',
      image: 'Produkt image',
      description: 'Description',
      type: 'Offertype',
      bundleProducts: 'Included products',
      category: 'Category',
      domain: 'Domain',
      location: 'Location',
      editorGroupId: 'Further editors',
      bookingCriteria: 'Target audience',
      targetUsers: 'Target users',
      availability: 'Availability',
      pickUpAndReturnTimes: 'Lender availability',
      alwaysAvailable: 'Always Available',
      independentOfLenderTimes: 'independent of pick-up/return times of the lender',
      bookingSlot: { name: 'Timeperiod', start: 'Start', end: 'End' },
      pickers: {
        startend: 'Start-End-Picker',
        recurringInterval: 'Recurring interval'
      },
      maxBooking: 'Maximum booking duration',
      maxPreBooking: 'Maximum pre-booking time',
      preparationTime: 'Setup time',
      reactionTime: 'Reaction time',
      maxArticleAmount: 'Maximum amount',
      amountPossible: 'Amount possible?',
      lender: { email: 'Contact-Email', number: 'Contactnumber' },
      bookingMailActive: 'Receive email-notifications on booking',
      hint: 'Organizational hint',
      units: { MINUTE: 'Minutes', HOUR: 'Hours', DAY: 'Days', WEEK: 'Weeks', MONTH: 'Months' },
      types: { BASIC: 'Product', BUNDLE: 'Bundle' },
      steps: {
        generalInformation: {
          title: 'General information',
          text: 'This information helps to identify the product'
        },
        description: {
          title: 'Description',
          text: 'Detailed description of the product'
        },
        type: {
          title: 'Product type',
          text: 'What kind of product is it?'
        },
        bundleProducts: {
          title: 'Products in the bundle',
          text: 'Which products are part of the bundle?'
        },
        category: {
          title: 'Category of the product',
          text: 'What is the category of the product?'
        },
        domainAndLocation: {
          title: 'Area and location',
          text: 'To which area is this product assigned and where is it located?',
          editInfo: 'Saving this offer will create the new domain "{{domain}}"'
        },
        editorGroup: {
          title: 'Further editors',
          text: 'Who else can edit this offer besides the lender?'
        },
        bookingCriteria: {
          title: 'Target audience',
          text: 'Which target group may book this product?\nOther target groups do not see the object'
        },
        bookingSlots: {
          title: 'Available Timeperiods',
          text: 'Enter the available timeperiods for this offer'
        },
        intervals: {
          title: 'Maximum booking duration and setup time',
          text: 'What is the maximum time the product can be booked and how long is needed between return and next possible booking?',
          editInfo: 'Existing bookings are not affected by a change of the preparation time.',
          maxPrebookingInfo: 'This is the maximum time that a product can be booked in advance.',
          preparationTimeInfo:
            'The preparation time is the time required between return and renewed dispensing in order to prepare the article for dispensing again.',
          reactionTimeInfo:
            'The reaction time is the time required between booking and collection to prepare the item for issue.',
          isIndependentOfLenderTimes:
            'If this toggle is activated, the product can be booked regardless of the specified pick-up and return times of the lender.'
        },
        amount: {
          title: 'Item amount',
          text: 'Can the product be borrowed multiple times? What is the maximum number of times it can be borrowed?',
          maxAmountInfo:
            'This is the maximum amount of items that a borrower may borrow for the product at one time'
        },
        lender: {
          title: 'Information about the lender',
          text: 'With these information people that are interested in the product can contact the lender'
        },
        internalNote: {
          title: 'Note from lender',
          text: 'Appears on the product overview only for lenders'
        },
        more: {
          title: 'More hints and notes',
          text: 'More optional hints and notes for the offer'
        }
      },
      placeholder: {
        uploadImage: 'Upload Image',
        hint: "e.g. 'Booking by tel. arrangement' or 'Please contact Mr. ... before return'",
        internalNote: "e.g. 'Product needs access code'",

        enterEmail: 'Contact-Email',
        enterNumber: 'e.g. +49 123 123123'
      }
    },
    tooltips: {
      editors: 'This field is only visible to editors of this offer',
      lenderGroupIdDisabled:
        'The lender group of a product can not be changed. Please clone the product to change the lender group.'
    },
    tabs: {
      product: 'Product',
      articles: 'Articles',
      bookings: 'Bookings'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Really delete?',
        message: 'Do you really want to delete this offer?'
      },
      cloneConfirm: {
        title: 'Really clone?',
        message: 'Do you really want to clone this offer?'
      }
    },
    alerts: {
      error: {
        getProducts: 'The products could not be loaded',
        getAvailabilities: 'The availabilities could not be loaded. Please try again later.',

        notFound: 'The product could not be found',
        openFailed: 'The product could not be openend',
        openCreateFailed: 'An error occurred while loading the page'
      },
      successfulCreate: 'The product has been created',
      successfulUpdate: 'The product has been updated',
      successfulDelete: 'The product has been deleted',
      successfulClone: 'The offer has been cloned',
      failedCreate: 'The product could not be created',
      failedUpdate: 'The product could not be updated',
      failedDelete: 'The product could not be deleted',
      failedClone: 'The offer could not be cloned',
      failedImageUpload: 'The image could not be uploaded.'
    },
    detailPage: {
      options: 'Additional options',
      selectOption: 'Select an option'
    },
    showArticles: 'Show available articles'
  },
  booking: {
    editModalTitle: 'Edit booking',
    noRows: 'No bookings yet.',
    columns: {
      userId: 'Borrower',
      start: 'Pick up',
      end: 'Return'
    },
    validation: {
      conflictBookings: 'There are conflicts with other bookings'
    },
    alerts: {
      successfulUpdate: 'The booking has been updated.',
      successfulCancel: 'The booking has been canceled.',
      failedUpdate: 'The booking could not be updated.',
      failedCancel: 'The booking could not be canceled.'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Really cancel?',
        message: 'Do you really want to cancel the booking?'
      }
    },
    warnings: {
      availableArticle: {
        title: 'Available articles',
        messagePart1:
          'Here you can see all article numbers for this product. If a warning symbol appears after an article number, it cannot be exchanged as there is a conflict with another booking. If you select this anyway, the conflict bookings will be displayed. However, the system then blocks storage with an article number that has already been assigned.',
        messagePart2:
          'If necessary, you can resolve the conflict manually (e.g. by cancelling or changing the collection/return period) and then try to exchange the article number again. The warning symbol will then disappear.',
        messagePart3:
          'Please note that if the set-up time is changed in the meantime, this may affect the processing of bookings.'
      }
    },
    tooltips: {
      skuDisabled:
        'It is not possible to change the article number as the booking has already been collected.'
    }
  },
  option: {
    noOptions: 'No options available',
    create: {
      heading: 'New Option',
      title: 'Title',
      description: 'Description',
      image: 'Optionimage',
      count: 'Amount',
      createModalTitle: 'Create Option',
      editModalTitle: 'Edit Option'
    },
    alerts: {
      successfulCreate: 'The option has been created.',
      successfulUpdate: 'The option has been updated.',
      successfulDelete: 'The option has been deleted.',
      failedCreate: 'The option could not be created.',
      failedUpdate: 'The option could not be updated.',
      failedDelete: 'The option could not be deleted.',
      failedImageUpload: 'The image could not be uploaded.'
    },
    dialogs: {
      deleteConfirm: {
        title: 'Really delete?',
        message: 'Do you really want to delete this option?'
      }
    }
  },
  article: {
    name: 'Article',
    columns: {
      articleId: 'SKU',
      visibility: 'Visibility'
    },
    create: {
      createHeading: 'New Article',
      editHeading: 'Edit Article',
      articleId: 'SKU',
      isVisible: 'Visibility',
      steps: {
        articleId: {
          title: 'Unique Identifier',
          text: 'Enter the unique identifier for this article'
        },
        isVisible: {
          title: 'Visibility',
          text: 'Controls whether this article is visible',
          editInfo: 'Existing bookings are not affected by a change of the visibility.'
        },
        internalNote: {
          title: 'Internal note from the lender',
          text: 'Appears in the article overview only for lenders'
        }
      }
    },
    dialogs: {
      deleteConfirm: {
        title: 'Really delete?',
        message: 'Do you really want to delete this article?'
      }
    },
    alerts: {
      successfulCreate: 'The article has been created.',
      successfulUpdate: 'The article has been updated.',
      successfulDelete: 'The article has been deleted.',
      failedCreate: 'The article could not be created.',
      failedUpdate: 'The article could not be updated.',
      failedDelete: 'The article could not be deleted.'
    }
  },
  orders: {
    heading: 'Order from {{customerName}}',
    tabs: {
      overview: 'Order overview',
      picking: 'Picking list',
      pickup: 'Pickup',
      return: 'Return'
    },
    columns: {
      articleCount: 'Article count',
      pickupDate: 'Pickup date',
      returnDate: 'Return date'
    },
    articleInOrder: 'Articles in the order',
    pickup: {
      columns: {
        articleNumber: 'Article number',
        articleName: 'Article name',
        internalNote: 'Internal note',
        plannedPickup: 'Planned pickup',
        collectedAt: 'Collected at',
        plannedReturn: 'Planned return',
        returnedAt: 'Returned at',
        commentByBorrower: 'Comment by borrower'
      }
    },
    orderNumber: 'Order number',
    orderDate: 'Order date',
    cancelOrder: 'Cancel order',
    dialogs: {
      cancelOrder: {
        title: 'Really cancel?',
        message: 'Do you really want to cancel the order?'
      }
    }
  },
  shoppingCart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty',
    products: 'Products',
    options: 'Options',
    orderNow: 'Order now',
    steps: {
      availability: 'Availability',
      options: 'Bookable options'
    },
    modalTitle: 'Productconfiguration',
    modalInfoTitleMaxBooking: 'Maximum bookingduration',
    modalInfoTextMaxBooking: 'This product has a maximum bookingduration of {{maxBooking}}.',
    modalInfoTextMaxBookingWithMaxPrebooking:
      'This product has a maximum booking duration of {{maxBooking}} and can be booked up to a maximum of {{maxPreBooking}} days in advance.',
    modalInfoTitleAvailabilityTime: 'Pickup and Return',
    modalInfoTextAvailabilityTime: 'Pickup and Return is only possible during following times: ',
    modalInfoTextNotice: 'Please notice the infos about bookingduration and pickup and return',
    noOptions: 'No options available for this offer',
    bookingDay: 'Booking day',
    notAvailable: 'This offer is currently not available',
    articleNotAvailable: 'Article not available anymore',
    pickUpTime: 'Pickup Time',
    returnTime: 'Return Time',
    availableArticle: 'Available articles',
    amount: 'Amount',
    comment: 'Comment',
    bundleContent: 'Bundle content',
    alerts: {
      successfulCreate: 'Added to shopping cart',
      successfulUpdate: 'Shopping cart has been updated',
      failedCreate: 'An error has occurred while adding to shopping cart',
      failedUpdate: 'An error has occurred while updating the shopping cart',
      successfulOrder: 'Order has been made',
      failedOrder: 'An error has occurred while ordering',
      noArticleAvailable:
        'The offer with the ID {{productId}} is not available in the selected timeperiod'
    },
    placeholder: { comment: "e.g. 'Please hand it to Mr. Huber'" },
    tooltips: {
      goToProduct: 'Go to offer'
    }
  },
  daily: {
    title: 'Daily Dashboard',
    today: 'Today',
    selectDay: 'Select day',
    overdue: 'Overdue',
    conflicting: 'Conflicting soon',
    noBookings: 'No bookings',
    lenderGroup: 'Domain',
    buttonLabels: {
      approvePicking: 'Approve picking',
      approveCollection: 'Approve collection',
      approveReturn: 'Approve return'
    },
    colorLegend: 'Legend',
    tooltips: {
      disabledEdit: {
        returned: 'Editing is disabled because the product has already been returned',
        notLender: 'Editing is disabled because you are not the lender of this product'
      },
      disabledCancel: {
        collected: 'Canceling is disabled because the product has already been picked up',
        notLender: 'Canceling is disabled because you are not the lender of this product'
      }
    },
    alerts: {
      overdue:
        'This order contains at least one item that is either overdue for collection or return. Please contact the borrower.',
      conflicting:
        'This order contains at least one item that is overdue and has already been booked in another order. Please contact the borrower.',
      conflictingOrderList: 'The following orders are affected: '
    },
    tabs: {
      pickups: 'Pickups',
      returns: 'Returns'
    }
  },
  statistics: {
    title: 'Statistics'
  },
  access: {
    title: 'Access control',
    columns: {
      lenderGroup: 'Lender group',
      entitlements: 'Entitlements'
    },
    alerts: {
      deleteSuccess: 'Group successfully deleted',
      deleteFailed: 'Group could not be deleted',
      createSuccess: 'Group successfully created',
      createFailed: 'Group could not be created',
      updateSuccess: 'Group successfully updated',
      updateFailed: 'Group could not be updated'
    }
  },
  terms: {
    title: 'Terms of use',
    text1:
      'You hereby agree to the terms of use of the leihBar of Rosenheim University of Applied Sciences and undertake to use the offers available in the leihBar exclusively in the university context and to treat them with care.',
    text2: 'The complete version of the',
    text3: 'Terms of use can be found here.'
  }
};

export default en;
